import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export const LoginPage: React.FC = () => {
    const { login, register, loading, error } = useAuth();
    const [mode, setMode] = useState<'login' | 'register'>('login');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nombre, setNombre] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (mode === 'login') {
            await login(email, password);
        } else {
            await register(nombre, email, password);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl mx-auto flex items-center justify-center text-3xl text-white mb-4">
                        📋
                    </div>
                    <h1 className="text-2xl font-bold text-slate-800">Minotion</h1>
                    <p className="text-sm text-slate-500 mt-1">
                        Sistema de gestión de proyectos Kanban
                    </p>
                </div>

                <div className="flex gap-2 mb-6 bg-slate-100 p-1 rounded-lg">
                    <button
                        onClick={() => setMode('login')}
                        className={`flex-1 py-2 text-sm rounded-md transition-colors ${
                            mode === 'login' ? 'bg-white shadow-sm text-slate-800 font-medium' : 'text-slate-600'
                        }`}
                    >
                        Iniciar sesión
                    </button>
                    <button
                        onClick={() => setMode('register')}
                        className={`flex-1 py-2 text-sm rounded-md transition-colors ${
                            mode === 'register' ? 'bg-white shadow-sm text-slate-800 font-medium' : 'text-slate-600'
                        }`}
                    >
                        Registrarse
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    {mode === 'register' && (
                        <div>
                            <label className="block text-xs font-medium text-slate-600 mb-1">Nombre</label>
                            <input
                                type="text"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                required
                                className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                    )}
                    <div>
                        <label className="block text-xs font-medium text-slate-600 mb-1">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-slate-600 mb-1">Contraseña</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength={6}
                            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        {mode === 'register' && (
                            <p className="text-xs text-slate-400 mt-1">Mínimo 6 caracteres</p>
                        )}
                    </div>

                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2 rounded-lg">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all disabled:opacity-50"
                    >
                        {loading ? 'Procesando...' : (mode === 'login' ? 'Entrar' : 'Crear cuenta')}
                    </button>
                </form>

                <p className="text-xs text-slate-400 mt-6 text-center">
                    Multi-usuario · roles y permisos · JWT · Kanban con métricas ágiles
                </p>
            </div>
        </div>
    );
};